export function triggerCleanupEvent(): void {
    const event: CustomEvent = new CustomEvent('globalCleanup', {
        detail: { message: 'Time to clean up!' }
    });
    window.dispatchEvent(event);
}